class SafeSticky extends HTMLElement {
  connectedCallback() {
    this.initSticky();
    window.addEventListener('resize', this.initSticky.bind(this));
  }

  initSticky() {
    const top = parseInt(this.style.top) || 0;
    const elementHeight = this.offsetHeight;
    const windowHeight = window.innerHeight;

    if (elementHeight + top < windowHeight) {
      this.style.position = 'sticky';
    } else {
      this.style.position = 'static';
    }
  }
}

customElements.define('safe-sticky', SafeSticky);
